export const DEFAULT_ZOOM = 1;
export const MAX_ZOOM = 2;
export const MIN_ZOOM = 0.5;
export const ZOOM_FACTOR = 0.2;
export const MIN_MOUSE_SPEED = 1000;